export const COURSES = [
  {
    id: "primeros-auxilios-basicos-montana",
    lessons: "44 Lecciones Online",
    title: "Primeros Auxilios Básicos - Montaña",
    desc: "Protocolos PAS, inmovilizaciones de emergencia, hipotermia y triage en terreno hostil y montaña gallega.",
    instructors: ["Javier Ferreira", "Samuel Irigoyen Crujeiras"],
    units: [
      {
        name: "XERAL",
        topics: ["Avisos", "Presentación", "Novas e Anuncios"],
      },
      {
        name: "UD01 - ASPECTOS XERAIS",
        topics: [
          "Tema 01 - Socorrismo: Aproximación a la emergencia",
          "Tema 02 - Socorrismo: Actuación con la víctima",
          "Tema 03 - Autoprotección",
          "Tema 04 - Avaliación Inicial",
        ],
      },
      {
        name: "UD02 - SOPORTE VITAL BÁSICO",
        topics: [
          "Tema 01 - Protocolo PAS",
          "Tema 02 - Valoración primaria (XABC)",
          "Tema 03 - Reanimación cardiopulmonar",
          "Tema 04 - Uso del DESA",
          "Tema 05 - Posición lateral de seguridad",
        ],
      },
      {
        name: "UD03 - LESIONES Y TRAUMATISMOS",
        topics: [
          "Tema 01 - Hemorragias y heridas",
          "Tema 02 - Fracturas e inmovilizaciones",
          "Tema 03 - Quemaduras",
          "Tema 04 - Lesiones medulares",
        ],
      },
      {
        name: "UD04 - EMERGENCIAS EN MONTAÑA",
        topics: [
          "Tema 01 - Hipotermia y congelación",
          "Tema 02 - Golpe de calor y deshidratación",
          "Tema 03 - Mal de altura",
          "Tema 04 - Extracción y traslado de víctimas en terreno escarpado",
        ],
      },
      {
        name: "UD05 - TRIAGE Y EMERGENCIAS MÚLTIPLES",
        topics: [
          "Tema 01 - Sistema de triage",
          "Tema 02 - Comunicación con servicios de emergencia (112)",
          "Tema 03 - Prueba final y evaluación",
        ],
      },
    ],
  },
  {
    id: "formacion-coeducacion",
    lessons: "4 Lecciones Online",
    title: "Formación en Coeducación",
    desc: "Módulos pedagógicos para formadores de salvamento, trabajo en equipo y convivencia en operativos.",
    instructors: ["Javier Ferreira"],
    units: [
      {
        name: "XERAL",
        topics: ["Avisos", "Presentación"],
      },
      {
        name: "MÓDULOS",
        topics: [
          "Módulo 1 - Fundamentos de coeducación",
          "Módulo 2 - Trabajo en equipo en operativos",
          "Módulo 3 - Convivencia e igualdad en el voluntariado",
          "Módulo 4 - Evaluación final",
        ],
      },
    ],
  },
  {
    id: "salvamento-maritimo",
    lessons: "Próxima edición",
    title: "Salvamento Marítimo",
    desc: "Actuación en rescate acuático: aproximación a la víctima, manejo de material de flotación y señalización en la costa.",
    instructors: ["Javier Ferreira", "David Hernáez Rodríguez"],
    units: [
      {
        name: "XERAL",
        topics: ["Avisos", "Presentación"],
      },
      {
        name: "UD01 - RESCATE ACUÁTICO",
        topics: [
          "Tema 01 - Lectura del medio acuático (ría y costa)",
          "Tema 02 - Aproximación y contacto con la víctima",
          "Tema 03 - Material de flotación y auxilio",
          "Tema 04 - Extracción y primeros cuidados en orilla",
        ],
      },
    ],
  },
  {
    id: "busqueda-de-personas",
    lessons: "Próxima edición",
    title: "Búsqueda de Personas",
    desc: "Metodología de búsqueda de desaparecidos: batidas, orientación y coordinación de equipos en terreno abierto.",
    instructors: ["Samuel Irigoyen Crujeiras"],
    units: [
      {
        name: "XERAL",
        topics: ["Avisos", "Presentación"],
      },
      {
        name: "UD01 - BÚSQUEDA EN TERRENO ABIERTO",
        topics: [
          "Tema 01 - Planificación del dispositivo de búsqueda",
          "Tema 02 - Batidas y patrones de rastreo",
          "Tema 03 - Orientación con mapa, brújula y GPS",
          "Tema 04 - Coordinación con fuerzas de seguridad",
        ],
      },
    ],
  },
];
